import { EditItem, IEditItem } from "../common/editItem";
import { RiskAssesmentFrequency, RiskType } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IRiskEditItem extends IEditItem {
    unitId: string;
    riskCategoryId: string;
    riskType: RiskType;
    date: number;
    code: string;
    title: string;
    description: string;
    threat: string;
    controls: string;
    owner: string;
    assesmentFrequency: RiskAssesmentFrequency;
    opportunity: boolean;
    opportunityBenefit: string;
    opportunityDescription: string;
    isRead: boolean;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    publishUser: IModifyUser;
    archiveUser: IModifyUser;
    deleteUser: IModifyUser;
    lockedUser: IModifyUser;

    isLockedToOtherUser(userCode: string): boolean;
}

export class RiskEditItem extends EditItem implements IRiskEditItem {
    unitId: string;
    riskCategoryId: string;
    riskType: RiskType;
    date: number;
    code: string;
    title: string;
    description: string;
    threat: string;
    controls: string;
    owner: string;
    assesmentFrequency: RiskAssesmentFrequency;
    opportunity: boolean;
    opportunityBenefit: string;
    opportunityDescription: string;
    isRead: boolean;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    publishUser: IModifyUser;
    archiveUser: IModifyUser;
    deleteUser: IModifyUser;
    lockedUser: IModifyUser;

    constructor();
    constructor(obj: IRiskEditItem);
    constructor(obj?: any) {
        super(obj);
        this.unitId = obj && obj.unitId || "";
        this.riskCategoryId = obj && obj.riskCategoryId || "";
        this.riskType = obj && obj.riskType || RiskType.Risk;
        this.date = obj && obj.date || 0;
        this.code = obj && obj.code || "";
        this.title = obj && obj.title || "";
        this.description = obj && obj.description || "";
        this.threat = obj && obj.threat || "";
        this.controls = obj && obj.controls || "";
        this.owner = obj && obj.owner || "";
        this.assesmentFrequency = obj && obj.assesmentFrequency || RiskAssesmentFrequency.Continuous;
        this.opportunity = obj && obj.opportunity || false;
        this.opportunityBenefit = obj && obj.opportunityBenefit || "";
        this.opportunityDescription = obj && obj.opportunityDescription || "";
        this.isRead = obj && obj.isRead || false;
        this.createUser = new ModifyUser(obj?.createUser);
        this.modifyUser = new ModifyUser(obj?.modifyUser);
        this.publishUser = obj?.publishUser ? new ModifyUser(obj.publishUser) : null;
        this.archiveUser = obj?.archiveUser ? new ModifyUser(obj.archiveUser) : null;
        this.deleteUser = obj?.deleteUser ? new ModifyUser(obj.deleteUser) : null;
        this.lockedUser = obj?.lockedUser ? new ModifyUser(obj.lockedUser) : null;
    }

    isLockedToOtherUser(userCode: string): boolean {
        return this.lockedUser?.code && !userCode.equalIgnoreCase(this.lockedUser.code);
    }
}